<template>
<n-space justify="space-between">
    <n-space v-if="isMobile" class="menu_button_small">
        <account-menu></account-menu>
    </n-space>
    <n-space>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 744 1052" :class="isMobile ? 'logo_small' : 'logo_medium'">
            <path d="m36.1624,731.753c-6.9775-16.5937 21.7169-28.7174 32.8571-42.8571 7.9623-10.1061 17.2589-19.2224 24.2857-30 10.2358-15.6996 16.7772-33.5265 25.7143-50 9.5559-27.3902 11.9672-49.3606 34.2857-60-14.1025-29.2538 2.566-61.0557 5.7143-91.4286-7.0256-31.6946-6.025-60.2585 12.8572-88.5714-4.457-13.4215-35.412-16.9344-30-30 3.6446-8.7988 22.6498,7.4591 28.5714,0-49.2364-29.3826-57.8598-92.1737-24.2857-104.2857-16.8153,56.3196 12.9463,60.8333 37.1429,74.2857 8.2849-1.7373 17.0329-22.9027 77.1428-7.1429 18.083,1.6474 25.2268-13.846 58.5714,10 22.8283-13.8571 58.4563,14.6469 52.8571-74.2857 53.4778,89.8433-31.4908,64.635-20,95.7143 2.2217,6.0089 15.1894,6.5147 14.2857,12.8572-2.163,15.1812-35.86,5.7123-41.4286,20-11.7206,30.0724-2.9029,66.1325 35.7143,90 35.8971,8.326 49.3258,32.976 80,55.7143 42.6006-.6588 85.3826,23.525 108.5714,32.8571 146.0699-84.8465-56.5656-37.3761-48.5714-94.2857 4.1547-26.6151 41.0264-35.5585 57.1429-57.1429 11.3461-15.1955-25.1355-44.0457 27.1429-50-13.1512,26.7972 24.149,22.5866 14.2437,70.1015-48.8833,24.5331-83.4329,18.0782-71.8049,48.8165 42.6525,7.8687 158.0737,8.9842 42.3372,94.0109 12.5175,17.9569 38.863,19.1402 53.7955,54.2139 12.183,14.7807 22.5251,31.0139 32.8571,47.1429 12.6904,7.2452 29.9876,12.3599 38.5714,65.7143 9.2186,16.0938 35.6296,32.08 27.1429,48.5714-3.9463,7.6683-15.4812,3.5597-25.7143,2.8571-9.5614-6.2965-4.4398-22.8497-10-32.8571-21.5176-7.2137-17.4763-25.6968-30-34.2857-50.0257-14.9105-48.1921-30.9025-74.2857-27.1429 .8055,59.0851-22.5007,30.986-32.8571,24.2857-15.4674,27.4347-32.7313,7.7567-38.5714-5.7143-9.05-.4279-18.7811-2.0595-27.1428,1.4286-6.5334,2.7254-15.0067,7.2421-15.7143,14.2857-1.7706,17.6266 36.1816,25.7914 31.4286,42.8571-4.9827,17.8905-33.0675,18.6412-51.4286,21.4286-15.1316,2.2971-11.8576,4.5404-45.7143-4.2857-3.5262-14.7785 39.9873-9.1585 38.5714-24.2857-1.574-16.8162-33.0184-9.3108-47.1429-18.5714-6.195-4.0617-15.1033-8.3317-15.7143-15.7143-.6757-8.1648 17.5519-12.4865 14.2857-20-47.394,11.704-62.9362.3264-87.1429-11.4286-10.6619,2.5507-18.2096,12.2171-27.1429,18.5714-11.0981,7.8943-21.8988,16.1986-32.8571,24.2857-9.0427,6.6734-18.7271,12.5516-27.1429,20-8.8287,7.8139-12.7783,23.1489-24.2857,25.7143-16.485,3.675-45.1591-1.7987-47.1429-18.5714-2.7309-23.0896 41.9546-22.3958 57.1429-40 13.9114-16.1242 35.8963-37.1463 28.5714-57.1429-44.6272,12.4254-55.9656-4.9993-60-25.7143-7.8923,1.8631-9.8671,12.9527-15.7143,18.5714-21.7727,20.9223-47.5679,26.0304-61.4286,52.8571-4.8138,9.3169-3.4237,27.5108-11.4286,34.2857-12.0827,10.2262-41.0072,8.8775-47.1429-5.7143z" fill="#ff0000"/>
        </svg>
    </n-space>
    <n-space :class="isMobile ? 'timeframe_button_group_small' : 'timeframe_button_group_medium'">
        <n-dropdown v-model:value="selectedTimeFrame" :options="timeFrameOptions" placement="bottom-start" @select="selectTimeFrame">
            <n-button icon-placement="right">
                <n-icon v-if="!isMobile">
                    <timerange-icon />
                </n-icon>
                <div v-if="!isMobile">&nbsp;</div> {{ selectedTimeFrameValue }}
                <template #icon>
                    <n-icon>
                        <arrow-down-icon />
                    </n-icon>
                </template>
            </n-button>
        </n-dropdown>
        <n-button-group v-if="!isMobile">
            <n-tooltip trigger="hover">
                <template #trigger>
                    <n-button @click="refreshDashboard">
                        <template #icon>
                            <n-icon v-if="!loadingRef">
                                <refresh-icon/>
                            </n-icon>
                            <n-icon v-if="loadingRef">
                                <refresh-icon class="loading_indicator"/>
                            </n-icon>
                        </template>
                    </n-button>
                </template>
                <span>Refresh dashboard</span>
            </n-tooltip>
            <n-dropdown v-model:value="selectedRefreshInterval" :options="refreshIntervals" placement="bottom-end" @select="selectRefreshInterval">
                <n-button icon-placement="right">
                    <n-text type="primary">
                        {{ selectedRefreshIntervalValue }}
                    </n-text>
                    <template #icon>
                        <n-icon>
                            <arrow-down-icon />
                        </n-icon>
                    </template>
                </n-button>
            </n-dropdown>
        </n-button-group>
        <n-button @click="handleLogout">
            <template #icon>
                <n-icon>
                    <log-out-icon/>
                </n-icon>
            </template>
        </n-button>
    </n-space>
  </n-space>
</template>

<script>
import { ref, defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import { RouterLink } from 'vue-router'
import { useMobile } from '@/composables/mobile'
import { NConfigProvider, NGlobalStyle, NMessageProvider, useMessage, useLoadingBar, NLoadingBarProvider, NIcon } from 'naive-ui'
import { Refresh as RefreshIcon, Logout as LogOutIcon } from "@vicons/tabler";
import { CaretDownOutline } from "@vicons/ionicons5";
import { KeyboardArrowDownOutlined as ArrowDownIcon, AccessTimeOutlined as TimerangeIcon } from "@vicons/material";
import { SET_ACTIVE_REFRESH_INTERVAL, SET_ACTIVE_TIMEFRAME, AUTH_LOGOUT } from '@/store/mutation-types';
import AccountMenu from '@/components/AccountMenu.vue'


export default defineComponent({
    name: 'NavHeader',
    components: {
        NConfigProvider, NGlobalStyle, NMessageProvider, NLoadingBarProvider, RouterLink, NIcon,
        TimerangeIcon, RefreshIcon, ArrowDownIcon, LogOutIcon, CaretDownOutline,
        AccountMenu,
    },

    setup() {
        const store = useStore()
        const message = useMessage()
        const { isMobile } = useMobile()
        
        // refs
        const timeFrameOptions = ref( store.state.settings.timeFrameOptions )
        const refreshIntervals = ref( store.state.settings.refreshIntervals )

        // computed properties
        const selectedTimeFrame = computed(() => store.getters['settings/getActiveTimeFrame'] )
        const selectedTimeFrameValue = computed(() => store.getters['settings/getActiveTimeFrameValue'] )
        const selectedRefreshInterval = computed(() => store.getters['settings/getActiveRefreshInterval'] )
        const selectedRefreshIntervalValue = computed(() => store.getters['settings/getActiveRefreshIntervalValue'] )
        const loadingRef = computed(() => store.getters['settings/getLoadingRef'] )

        // methods
        const handleLogout = async () => {
            try {
                const response = await store.dispatch('auth/authLogout');
                message.success(response.message)
                store.commit(`auth/${AUTH_LOGOUT}`)
            } catch (error) {
                message.error(String(error));
            }
        }

        // lifecycle hooks

        return {
            isMobile: isMobile(),
            // datetimerange related
            selectedTimeFrame, 
            selectedTimeFrameValue: selectedTimeFrameValue,
            timeFrameOptions,
            selectTimeFrame(key) {
                store.commit(`settings/${SET_ACTIVE_TIMEFRAME}`, key)
            },
            // refresh interval realted
            selectedRefreshInterval,
            selectedRefreshIntervalValue: selectedRefreshIntervalValue,
            refreshIntervals,
            selectRefreshInterval(key) {
                store.commit(`settings/${SET_ACTIVE_REFRESH_INTERVAL}`, key)
            },
            // button group
            refreshDashboard() {
                window.location.reload()
            },
            // logout button
            handleLogout,
            loadingRef, // loading indicator
        }
    }
})
</script>

<style scoped>
.logo_text {
    cursor: pointer;
}

.logo_small {
    height: 60px;
    width: 60px;
}
.logo_medium {
    height: 75px;
    width: 75px;
}

.menu_button_small {
    padding-top: 12px;
    padding-left: 10px;
    padding-bottom: 12px;
}
.menu_button_medium {
    padding-top: 24px;
    padding-left: 24px;
}

.timeframe_button_group_small {
    padding-top: 12px;
    padding-right: 10px;
    padding-bottom: 12px;
}
.timeframe_button_group_medium {
    padding-top: 24px;
    padding-right: 24px;
}

.router_link {
    text-decoration: none;
}
.loading_indicator {
    transform: rotate(40deg);
}
</style>
